import Text from '@/components/ui/custom/dataDisplay/Text';
import { twMerge } from 'tailwind-merge';

type PublishDateProps = {
  title: string;
  className?: string;
};

export default function Title({ title, className }: PublishDateProps) {
  return (
    <Text
      text={title}
      format="poppins-600"
      className={twMerge('truncate', className)}
    />
  );
}
